import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import BookingPage from './pages/BookingPage';
import ContactPage from './pages/ContactPage';
import DomesticPage from './pages/DomesticPage';
import DeepCleaningPage from './pages/DeepCleaningPage';
import EndOfTenancyPage from './pages/EndOfTenancyPage';
import CommercialPage from './pages/CommercialPage';
import CommunalCleaningPage from './pages/CommunalCleaningPage';
import OfficeCleaningPage from './pages/OfficeCleaningPage';
import BarsRestaurantsCleaningPage from './pages/BarsRestaurantsCleaningPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home/:area" element={<HomePage />} />
          <Route path="/book" element={<BookingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          
          {/* Legal Pages */}
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          
          {/* Domestic Routes */}
          <Route path="/domestic" element={<DomesticPage />} />
          <Route path="/domestic/:area" element={<DomesticPage />} />
          <Route path="/deep-cleaning" element={<DeepCleaningPage />} />
          <Route path="/deep-cleaning/:area" element={<DeepCleaningPage />} />
          <Route path="/end-of-tenancy" element={<EndOfTenancyPage />} />
          <Route path="/end-of-tenancy/:area" element={<EndOfTenancyPage />} />
          
          {/* Commercial Routes */}
          <Route path="/commercial" element={<CommercialPage />} />
          <Route path="/commercial/:area" element={<CommercialPage />} />
          <Route path="/communal-cleaning" element={<CommunalCleaningPage />} />
          <Route path="/communal-cleaning/:area" element={<CommunalCleaningPage />} />
          <Route path="/office-cleaning" element={<OfficeCleaningPage />} />
          <Route path="/office-cleaning/:area" element={<OfficeCleaningPage />} />
          <Route path="/bars-restaurants-cleaning" element={<BarsRestaurantsCleaningPage />} />
          <Route path="/bars-restaurants-cleaning/:area" element={<BarsRestaurantsCleaningPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;